module.exports = __webpack_public_path__ + "static/media/Daddy-No1.ff83c612.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/Daddy-No1.gif
// module id = 317
// module chunks = 0